module.exports = __webpack_public_path__ + "a05c8a38e365f2aa9673f3faf95adaa5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/beach-s.png
// module id = 2379
// module chunks = 0